import React, { useContext, useEffect, useState } from 'react';
import UserContext from '../../context/UserContext';
import axios from 'axios';
import moment from 'moment';
import { useNavigate, useLocation, useParams, useSearchParams } from 'react-router-dom';
import Moment from 'react-moment';

const CustFiles = () => {
  const [files, setFiles] = useState([]);
  const [filteredFiles, setFilteredFiles] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const { userInfo } = useContext(UserContext);
    const [company, setCompany ] = useState("");
  const location = useLocation();
  const path = window.location.pathname;
  const nav = useNavigate();
//   const [searchParams] = useSearchParams();

   const [searchParams] = useSearchParams();

  // Define allowed file extensions with their types (can be fetched from a database later)
  const ALLOWED_FILE_EXTENSIONS = [
    { extension: 'jpg', type: 'image' },
    { extension: 'jpeg', type: 'image' },
    { extension: 'png', type: 'image' },
    { extension: 'gif', type: 'image' },
    { extension: 'bmp', type: 'image' },
    { extension: 'pdf', type: 'pdf' },
    { extension: 'psd', type: 'adobe' },
    { extension: 'ai', type: 'adobe' },
  ];


  useEffect(() => {
let com = searchParams.get("c")
setCompany(com.replace(/[^0-9a-z-A-Z ]/g, "").replace(/ +/, " "))
  },[])

useEffect(() => {
 
  const getcustfiles = async () => {
    let hh = {
      id: searchParams.get("id"),
     company:searchParams.get("c")
    };
    await axios.post('https://plsuploader-7381434a72f8.herokuapp.com/files/getindvuserfiles', hh)
      .then((res) => {
       
        if (res.data.status == 200) {
          setFiles(res.data.message);
          setFilteredFiles(res.data.message);
       
        }
      })
      .catch((err) => console.error('API error:', err));
  };
  getcustfiles();
}, [userInfo]);

  useEffect(() => {
    if (searchQuery.trim() === '') {
      setFilteredFiles(files);
    } else {
      const filtered = files.filter((file) =>
        file.filename.toLowerCase().includes(searchQuery.toLowerCase())
      );
      setFilteredFiles(filtered);
    }
  }, [searchQuery, files]);

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const getFileType = (file) => {
    const extension = file.filename.split('.').pop().toLowerCase();
    const mimeType = file.type || '';
    const fileExt = ALLOWED_FILE_EXTENSIONS.find((ext) => ext.extension === extension);

    if (fileExt) {
      return fileExt.type;
    } else if (mimeType.includes('image')) {
      return 'image';
    } else if (mimeType.includes('pdf')) {
      return 'pdf';
    }
    return 'other';
  };

  const renderPreview = (file) => {
    const fileType = getFileType(file);
    const fileUrl = `https://plsprint.com/cats/${file.url}`;

    if (fileType === 'image') {
      return (
        <img
          src={fileUrl}
          alt="Preview"
          className="w-16 h-16 object-cover rounded transition-transform duration-200 hover:scale-200 hover:z-10 transform-origin-center"
          onError={(e) => (e.target.src = '/fallback-image.png')}
        />
      );
    } else if (fileType === 'pdf') {
      return (
        <object
          data={`${fileUrl}#page=1&zoom=10`}
          type="application/pdf"
          width="64"
          height="64"
          className="rounded"
          style={{ overflow: 'hidden', scroll: "none" }}
        >
          <img
            src="/pdf-icon.png"
            alt="PDF Preview"
            className="w-16 h-16 object-cover rounded"
          />
        </object>
      );
    } else {
      return <span className="text-gray-500 transform-none">No preview available</span>;
    }
  };

  const handleDownload = async (file) => {
    if (getFileType(file) !== 'image') return;

    const fileUrl = `${file.url}`;
  

    try {
      const response = await fetch(fileUrl, {
        method: 'GET',
        mode: 'cors',
        credentials: 'same-origin',
        headers: {
          'Accept': file.type || 'image/*',
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status} ${response.statusText}`);
      }

   

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = file.originalFilename || 'image';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Download failed:', error.message);
      console.error('Full error:', error);
      alert('Failed to download the image. Please try again or contact support.');
    }
  };

 console.log(filteredFiles)
  return (
    <>
      <div className="flex w-full h-[10vh] mt-[60px] px-[10vw] justify-center">
        <div className="flex-1">
          Search<br />
          <input
            className="w-full bg-transparent placeholder:text-slate-400 text-slate-700 text-sm border border-slate-200 rounded-md px-3 py-2 transition duration-300 ease focus:outline-none focus:border-slate-400 hover:border-slate-300 shadow-sm focus:shadow"
            placeholder="Type here..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        <div className='flex items-center justify-end ml-30'>
         <button
            type="button"
            className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            onClick={e => nav('/dashboard') }
          >
           Go to Dashboard
          </button>
        </div>

        <div className="flex-1" style={{ textAlign: 'right', marginTop: '25px' }}>
          <button
            type="button"
            className="text-white bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
            onClick={() => nav(`/dashboard/custfiles/upload?c=${searchParams.get('id')}`) }
          >
            Upload File
          </button>
        </div>
      </div>
      <div className="overflow-x-auto mt-[20px] px-[20px]">
       <div className='flex'>
       <div className='flex-1 text-left font-bold'>{files[0]?.company}</div> <div className='flex-1 text-left font-bold'>{filteredFiles?.length} Files Found</div>
       </div>
        <table className="min-w-full bg-white border border-gray-200">
          <thead>
            <tr className="bg-gray-100 border-b flex">
              <th className="flex-3 px-6 py-3 text-left text-sm font-medium text-gray-700">Name</th>
              <th className="flex-1 px-6 py-3 text-left text-sm font-medium text-gray-700">Uploaded By</th>
              <th className="flex-1 px-6 py-3 text-left text-sm font-medium text-gray-700">Date</th>
              <th className="flex-1 px-6 py-3 text-left text-sm font-medium text-gray-700">Size</th>
              <th className="flex-1 px-6 py-3 text-left text-sm font-medium text-gray-700">Type</th>
              {/* <th className="flex-1 px-6 py-3 text-left text-sm font-medium text-gray-700"></th> */}
              <th className="flex-1 px-6 py-3 text-left text-sm font-medium text-gray-700"></th>
            </tr>
          </thead>
          <tbody>
            {filteredFiles?.map((file, index) => (
              
              <tr key={index} className="flex border-b hover:bg-gray-50">
                <td className="flex-3 px-6 py-4 text-left text-sm text-gray-900 break-words ">{file.filename}</td>
                <td className="flex-1 px-6 py-4 text-left text-sm text-gray-900 break-words">{file.uploadName}</td>
                <td className="flex-1 px-6 py-4 text-left text-sm text-gray-900">
                <Moment format="MM/DD/YY hh:mm:ss">{file.createdAt}</Moment>
                </td>
                <td className="flex-1 px-6 py-4 text-left text-sm text-gray-900">{formatFileSize(file.size)}</td>
                <td className="flex-1 px-6 py-4 text-left text-sm text-gray-900">{file.type}</td>
                 {/* <td className="flex-1 px-6 py-4 text-sm">
                  <a
                    href={`https://plsprint.com/cats/${file.originalFilename}`}
                    download={file.originalFilename}
                    target="_blank"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                    Preview
                  </a>
                </td> */}
                <td className="flex-1 px-6 py-4 text-sm">
                  <a
                    href={`https://plsprint.com/${file.url.replace('/public_html', '')}`}
                    download={file.filename}
                    target="_blank"
                    className="text-blue-600 hover:text-blue-800 underline"
                  >
                     Preview / Download
                  </a>
                </td>
              </tr>
            )).reverse()}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default CustFiles;


